export const zoneMapper = zone => {
  const { id, name } = zone
  return { id, label: name, value: id }
}
